export enum AlertEventTypes {
  AddInstUIFlashMessage = 'addInstUIFlashMessage',
  ResetInstUIFlashMessages = 'resetInstUIFlashMessages',
}
